module.exports = __webpack_public_path__ + "img/chart-simple-light.7708155d.svg";